export const localeMessage = {
  en: {
    remove: `Remove`,
    locationNumber: `Location Number`,
    locationType: `Location Type`,
    locationTypeNormal: `Normal`,
    locationTypePromotion: `Promotion`,
    inventorySku: `Master SKU`,
    purchasePrice: `Purchase Price`,
    totalPurchasePrice: `Total Purchase Price`,
    totalPurchasePriceTooltip: `The total purchase amount of this batch of changed products`,
    stockNumberError: `Should be between 0 to 999,999`,
    priceError: `Should be between 0 and 1,000,000,000!`,
    priceUneditableTooltip: `Average Purchase Price`,
    masterSku: `Master SKU`,
    editUnitPurchasePriceDec2: `Use to the previous Unit Purchase Price of Master SKU`,
    editUnitPurchasePriceDec1: `Change Unit Purchase Price to`,
    editUnitPurchasePrice: `Edit Unit Purchase Price`,
    editRemarks: `Edit Remarks`,
    editWarehouseStockArticle1: `How to Edit Warehouse Stock?`,
    rupiah: `Rp`,
    pleaseEnter: `Please Enter`,
    unitPurchasePrice: `Unit Purchase Price`,
    warehouseName: `Warehouse Name`,
    adjustmentNo: `Adjustment No.`,
    remarkPlaceholder: `Please enter reason for edit, should be less than 300 characters`,
    name: `Name`,
    originalStock: `Original Stock`,
    movement: `Movement`,
    latestStock: `Latest Stock`,
    cancel: `Cancel`,
    confirm: `Confirm`,
    latestStockTooltip: `Stock refers to Warehouse Stock`,
    purchasePriceTooltip: `Inbound Purchase Price or outbound Purchase Price`,
    editSuccess: `Successfully Edited!`,
    action: `Action`,
    selected: `Selected`,
    clickToEdit: `Click to edit`,
    stockNegativeError: `New Warehouse Stock cannot be less than 0!`,
    stockAvailableError: `Final warehouse stock should be greater than (spare stock + locked stock = {sum})`,
    remark: `Remarks`,
    editMovement: `Edit Movement\uFF08+-\uFF09`,
    purchasePriceLimit: `Should be between 0 and 1,000,000,000!`,
    delete: `Delete`,
    stockNumberChangeError: `Should be -999,999 to -1 or 1 to 999,999`,
    noShelf: `Default Shelf`,
    NoDataInfo: `No data available to process`
  },
  zh: {
    remove: `\u79FB\u9664`,
    locationNumber: `\u8D27\u4F4D\u7F16\u53F7`,
    locationType: `\u8D27\u4F4D\u7C7B\u578B`,
    locationTypeNormal: `\u5E38\u89C4`,
    locationTypePromotion: `\u6D3B\u52A8`,
    inventorySku: `\u5E93\u5B58SKU`,
    purchasePrice: `\u91C7\u8D2D\u4EF7`,
    totalPurchasePrice: `\u91C7\u8D2D\u603B\u4EF7`,
    totalPurchasePriceTooltip: `\u672C\u6B21\u53D8\u52A8\u5546\u54C1\u7684\u91C7\u8D2D\u603B\u91D1\u989D`,
    stockNumberError: `\u8303\u56F4\u5E94\u662F0\u5230999,999`,
    priceError: `\u91D1\u989D\u5FC5\u987B\u57280 \u301C 1,000,000,000\u4E4B\u95F4\uFF01`,
    priceUneditableTooltip: `\u5546\u54C1\u7684\u5E73\u5747\u91C7\u8D2D\u4EF7`,
    masterSku: `\u4E3B SKU`,
    editUnitPurchasePriceDec2: `\u6CBF\u7528Master SKU\u5148\u524D\u7684\u91C7\u8D2D\u5355\u4EF7`,
    editUnitPurchasePriceDec1: `\u76F4\u63A5\u5C06\u91C7\u8D2D\u5355\u4EF7\u6539\u6210`,
    editUnitPurchasePrice: `\u7F16\u8F91\u91C7\u8D2D\u5355\u4EF7`,
    editRemarks: `\u7F16\u8F91\u5907\u6CE8`,
    editWarehouseStockArticle1: `\u5982\u4F55\u7F16\u8F91\u4ED3\u5E93\u5E93\u5B58?`,
    rupiah: `\u5370\u5C3C\u76FE`,
    pleaseEnter: `\u8BF7\u8F93\u5165`,
    unitPurchasePrice: `\u91C7\u8D2D\u5355\u4EF7`,
    warehouseName: `\u4ED3\u5E93\u540D\u79F0`,
    adjustmentNo: `\u8C03\u6574\u7F16\u53F7`,
    remarkPlaceholder: `\u8BF7\u8F93\u5165\u66F4\u65B0\u7684\u539F\u56E0,\u5E94\u8BE5\u5C11\u4E8E300\u4E2A\u5B57\u7B26`,
    name: `\u540D\u79F0`,
    originalStock: `\u539F\u5E93\u5B58`,
    movement: `\u53D8\u52A8\u503C`,
    latestStock: `\u6700\u7EC8\u4ED3\u5E93\u5E93\u5B58`,
    cancel: `\u53D6\u6D88`,
    confirm: `\u786E\u5B9A`,
    latestStockTooltip: `\u5E93\u5B58\u6307\u4ED3\u5E93\u5E93\u5B58`,
    purchasePriceTooltip: `\u8FD9\u662F\u5165\u5E93\u91C7\u8D2D\u4EF7\u6216\u51FA\u5E93\u91C7\u8D2D\u4EF7`,
    editSuccess: `\u7F16\u8F91\u6210\u529F`,
    action: `\u64CD\u4F5C`,
    selected: `\u5DF2\u9009\u4E2D`,
    clickToEdit: `\u70B9\u51FB\u53EF\u7F16\u8F91`,
    stockNegativeError: `\u65B0\u4ED3\u5E93\u5E93\u5B58\u4E0D\u80FD\u5C0F\u4E8E0`,
    stockAvailableError: `\u6700\u7EC8\u4ED3\u5E93\u5E93\u5B58\u5E94\u5927\u4E8E(\u5907\u7528\u5E93\u5B58+\u9501\u5B9A\u5E93\u5B58={sum})`,
    remark: `\u5907\u6CE8`,
    editMovement: `\u7F16\u8F91\u53D8\u52A8\u503C`,
    purchasePriceLimit: `\u91D1\u989D\u5FC5\u987B\u57280 \u301C 1,000,000,000\u4E4B\u95F4\uFF01`,
    delete: `\u5220\u9664`,
    stockNumberChangeError: `\u5E94\u662F-999,999\uFF5E-1\u62161\uFF5E999,999`,
    noShelf: `\u9ED8\u8BA4\u8D27\u67B6`,
    NoDataInfo: `\u6CA1\u6709\u53EF\u4EE5\u5904\u7406\u7684\u6709\u6548\u6570\u636E`
  },
  id: {
    remove: `Hapus`,
    locationNumber: `Nomor Lokasi`,
    locationType: `Tipe Lokasi`,
    locationTypeNormal: `Normal`,
    locationTypePromotion: `Promosi`,
    inventorySku: `Master SKU`,
    purchasePrice: `Harga Pembelian`,
    totalPurchasePrice: `Total Harga Pembelian`,
    totalPurchasePriceTooltip: `Jumlah total pembelian produk yang diubah dalam batch ini`,
    stockNumberError: `Harus antara 0 hingga 999.999`,
    priceError: `Harus diantara 0 dan 1.000.000.000!`,
    priceUneditableTooltip: `Harga Pembelian Rata-rata`,
    masterSku: `Master SKU`,
    editUnitPurchasePriceDec2: `Gunakan harga pembelian Master SKU sebelumnya`,
    editUnitPurchasePriceDec1: `Ubah langsung harga satuan pembelian menjadi`,
    editUnitPurchasePrice: `Edit Harga Pembelian`,
    editRemarks: `Edit Catatan`,
    editWarehouseStockArticle1: `Bagaimana Cara Edit Stok Gudang?`,
    rupiah: `Rp`,
    pleaseEnter: `Silakan Masukkan`,
    unitPurchasePrice: `Harga Beli Satuan`,
    warehouseName: `Nama Gudang`,
    adjustmentNo: `No. Penyesuaian`,
    remarkPlaceholder: `Harap masukkan alasan perubahan, harus kurang dari 300 karakter`,
    name: `Nama`,
    originalStock: `Stok Awal`,
    movement: `Perubahan`,
    latestStock: `Edit Stok Gudang Ke`,
    cancel: `Batalkan`,
    confirm: `Konfirmasi`,
    latestStockTooltip: `Stok mengacu ke Stok Gudang`,
    purchasePriceTooltip: `Harga Pembelian Inbound/Harga Pembelian outbound`,
    editSuccess: `Berhasil Diedit`,
    action: `Atur`,
    selected: `Dipilih`,
    clickToEdit: `Klik untuk edit`,
    stockNegativeError: `Stok Gudang Baru tidak boleh kurang dari 0!`,
    stockAvailableError: `Stok gudang akhir harus lebih besar dari (stok cadangan + stok terkunci + stok promosi = {sum})`,
    remark: `Catatan`,
    editMovement: `Edit Perubahan`,
    purchasePriceLimit: `Harus diantara 0 dan 1.000.000.000!`,
    delete: `Hapus`,
    stockNumberChangeError: `Harus -999.999 hingga -1 atau 1 hingga 999.999`,
    noShelf: `Rak Default`,
    NoDataInfo: `Tidak ada data untuk diproses`
  },
  th: {
    remove: `\u0E25\u0E1A`,
    locationNumber: `\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    locationType: `\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    locationTypeNormal: `\u0E18\u0E23\u0E23\u0E21\u0E14\u0E32`,
    locationTypePromotion: `\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19`,
    inventorySku: `\u0E2A\u0E15\u0E47\u0E2D\u0E01 SKU`,
    purchasePrice: `\u0E23\u0E32\u0E04\u0E32\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D`,
    totalPurchasePrice: `\u0E23\u0E32\u0E04\u0E32\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    totalPurchasePriceTooltip: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E23\u0E31\u0E49\u0E07\u0E19\u0E35\u0E49`,
    stockNumberError: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E070\uFF5E999,999`,
    priceError: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E070 \u301C 1,000,000,000`,
    priceUneditableTooltip: `\u0E23\u0E32\u0E04\u0E32\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D\u0E40\u0E09\u0E25\u0E35\u0E48\u0E22\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    masterSku: `SKU \u0E2B\u0E25\u0E31\u0E01`,
    editUnitPurchasePriceDec2: `\u0E43\u0E0A\u0E49\u0E23\u0E32\u0E04\u0E32\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E48\u0E27\u0E22\u0E02\u0E2D\u0E07SKU\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E14\u0E34\u0E21`,
    editUnitPurchasePriceDec1: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E48\u0E27\u0E22\u0E40\u0E1B\u0E47\u0E19`,
    editUnitPurchasePrice: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E48\u0E27\u0E22`,
    editRemarks: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38`,
    editWarehouseStockArticle1: `\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E04\u0E25\u0E31\u0E07`,
    rupiah: `\u0E23\u0E39\u0E40\u0E1B\u0E35\u0E22\u0E2B\u0E4C`,
    pleaseEnter: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01`,
    unitPurchasePrice: `\u0E23\u0E32\u0E04\u0E32\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E48\u0E27\u0E22`,
    warehouseName: `\u0E0A\u0E37\u0E48\u0E2D\u0E04\u0E25\u0E31\u0E07`,
    adjustmentNo: `\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02`,
    remarkPlaceholder: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15 \u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19 300 \u0E2B\u0E25\u0E31\u0E01`,
    name: `\u0E0A\u0E37\u0E48\u0E2D`,
    originalStock: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E40\u0E14\u0E34\u0E21`,
    movement: `\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27`,
    latestStock: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14`,
    cancel: `\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01`,
    confirm: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19`,
    latestStockTooltip: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E04\u0E37\u0E2D\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E04\u0E07\u0E04\u0E25\u0E31\u0E07`,
    purchasePriceTooltip: `\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E08\u0E31\u0E14\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E32\u0E40\u0E02\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E32\u0E2D\u0E2D\u0E01`,
    editSuccess: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    action: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    selected: `\u0E16\u0E39\u0E01\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    clickToEdit: `\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E44\u0E02`,
    stockNegativeError: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48\u0E04\u0E27\u0E23\u0E43\u0E2B\u0E0D\u0E48\u0E01\u0E27\u0E48\u0E32 0`,
    stockAvailableError: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22\u0E04\u0E27\u0E23\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 (\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E33\u0E23\u0E2D\u0E07+ \u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E25\u0E47\u0E2D\u0E01={sum})`,
    remark: `\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38`,
    editMovement: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27`,
    purchasePriceLimit: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 0 \u301C 1,000,000,000`,
    delete: `\u0E25\u0E1A`,
    stockNumberChangeError: `\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07-999,999\uFF5E-1\u0E2B\u0E23\u0E37\u0E2D1\uFF5E999,999`,
    noShelf: `\u0E0A\u0E31\u0E49\u0E19\u0E27\u0E32\u0E07\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19`,
    NoDataInfo: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E2B\u0E49\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25`
  },
  vn: {
    remove: `X\xF3a`,
    locationNumber: `M\xE3 v\u1ECB tr\xED`,
    locationType: `Lo\u1EA1i v\u1ECB tr\xED`,
    locationTypeNormal: `B\xECnh th\u01B0\u1EDDng`,
    locationTypePromotion: `Khuy\u1EBFn m\xE3i`,
    inventorySku: `SKU kho h\xE0ng`,
    purchasePrice: `Gi\xE1 mua v\xE0o`,
    totalPurchasePrice: `T\u1ED5ng ti\u1EC1n mua h\xE0ng`,
    totalPurchasePriceTooltip: `S\u1ED1 ti\u1EC1n mua h\xE0ng thay \u0111\u1ED5i`,
    stockNumberError: `Ph\u1EA1m vi ph\u1EA3i l\xE0 0 \u0111\u1EBFn 999,999`,
    priceError: `S\u1ED1 ti\u1EC1n ph\u1EA3i l\xE0 t\u1EEB 0 \u301C 1,000,000,000!`,
    priceUneditableTooltip: `Gi\xE1 mua h\xE0ng b\xECnh qu\xE2n`,
    masterSku: `Master SKU`,
    editUnitPurchasePriceDec2: `S\u1EED d\u1EE5ng gi\xE1 mua tr\u01B0\u1EDBc \u0111\xF3 c\u1EE7a ch\u1EE7 SKU`,
    editUnitPurchasePriceDec1: `Tr\u1EF1c ti\u1EBFp thay \u0111\u1ED5i \u0111\u01A1n gi\xE1 mua th\xE0nh`,
    editUnitPurchasePrice: `Ch\u1EC9nh s\u1EEDa \u0111\u01A1n gi\xE1 mua h\xE0ng`,
    editRemarks: `Ch\u1EC9nh s\u1EEDa ghi ch\xFA`,
    editWarehouseStockArticle1: `L\xE0m th\u1EBF n\xE0o \u0111\u1EC3 ch\u1EC9nh s\u1EEDa kho h\xE0ng`,
    rupiah: `Rupiah`,
    pleaseEnter: `Vui l\xF2ng nh\u1EADp`,
    unitPurchasePrice: `\u0110\u01A1n gi\xE1 mua h\xE0ng`,
    warehouseName: `T\xEAn kho h\xE0ng`,
    adjustmentNo: `\u0110i\u1EC1u ch\u1EC9nh m\xE3 s\u1ED1`,
    remarkPlaceholder: `Vui l\xF2ng nh\u1EADp l\xFD do c\u1EADp nh\u1EADt, n\xEAn \xEDt h\u01A1n 300 k\xFD t\u1EF1`,
    name: `T\xEAn`,
    originalStock: `T\xEAn kho g\u1ED1c`,
    movement: `Gi\xE1 tr\u1ECB bi\u1EBFn \u0111\u1ED9ng`,
    latestStock: `Kho h\xE0ng cu\u1ED1i c\xF9ng`,
    cancel: `H\u1EE7y`,
    confirm: `X\xE1c nh\u1EADn`,
    latestStockTooltip: `H\xE0ng t\u1ED3n kho l\xE0 \u0111\u1EC3 ch\u1EC9 kho h\xE0ng t\u1ED3n kho`,
    purchasePriceTooltip: `\u0110\xE2y l\xE0 gi\xE1 mua v\xE0o ho\u1EB7c gi\xE1 b\xE1n ra`,
    editSuccess: `Ch\u1EC9nh s\u1EEDa th\xE0nh c\xF4ng`,
    action: `Thao t\xE1c`,
    selected: `\u0110\xE3 ch\u1ECDn`,
    clickToEdit: `B\u1EA5m v\xE0o \u0111\u1EC3 ch\u1EC9nh s\u1EEDa`,
    stockNegativeError: `Kho h\xE0ng t\u1ED3n kho m\u1EDBi kh\xF4ng th\u1EC3 nh\u1ECF h\u01A1n 0`,
    stockAvailableError: `Kho h\xE0ng t\u1ED3n kho cu\u1ED1i c\xF9ng ph\u1EA3i l\u1EDBn h\u01A1n (kho h\xE0ng d\u1EF1 ph\xF2ng + T\u1ED3n kho b\u1ECB Kh\xF3a ={sum})`,
    remark: `Ghi ch\xFA`,
    editMovement: `Ch\u1EC9nh s\u1EEDa gi\xE1 tr\u1ECB bi\u1EBFn \u0111\u1ED9ng`,
    purchasePriceLimit: `S\u1ED1 ti\u1EC1n ph\u1EA3i t\u1EEB 0 \u301C 1,000,000,000!`,
    delete: `X\xF3a`,
    stockNumberChangeError: `Ph\u1EA3i l\xE0 -999.999 \uFF5E -1 ho\u1EB7c 1 \uFF5E 999.999`,
    noShelf: `K\u1EC7 h\xE0ng m\u1EB7c \u0111\u1ECBnh`,
    NoDataInfo: `Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u \u0111\u1EC3 x\u1EED l\xFD`
  }
};
